// Initialize.ts
import { startUpdateMonitoring } from './updateState';

// Start monitoring when the app initializes
const cleanup = startUpdateMonitoring();

// Optional: Clean up on app shutdown if needed
if (typeof window !== 'undefined') {
  window.addEventListener('unload', cleanup);
}
